interface VideoMessageProps {
  url: string;
}

export function VideoMessage({ url }: VideoMessageProps) {
  return (
    <div className="w-full overflow-hidden rounded-xl">
      <video
        src={url}
        controls
        muted
        autoPlay
        loop
        className="w-full rounded-xl max-w-full"
        style={{ maxHeight: '240px' }}
      >
        Your browser does not support the video element.
      </video>
    </div>
  );
}
